import React, { useEffect, useState } from 'react'
import axiosClient from '../../../axios/axiosClient';
import { Link } from 'react-router-dom';



function Notification() {

  const [notification, setNotification] = useState([]);
  const [loading, setLoading] = useState([]);
  const getNotifications = (url = '/notifications') =>{
    axiosClient
      .get(url)
      .then((response) => {
        console.log(response.data.data)
        setNotification(response.data.data)
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }
  useEffect(() => {
    getNotifications()
  }, []);
    return (
      <>
          { notification?.value > 0 && <ul className="notification-dropdown onhover-show-div">
                  <li>Notification <span className="badge rounded-pill badge-primary pull-right">{notification.value}</span></li>
                  {notification.notifications && 
                    notification.notifications.map((notify, index) => {
                      return (
                        <li key={index}>
                          <div className="media">
                            <div className="media-body">
                              <Link to={notify.link}>
                              <h6 className="mt-0">
                                <span>
                                  <i className="shopping-color" data-feather="shopping-bag"></i>
                                </span>
                                {notify.message} 
                                {/* <small className="pull-right">9:00 AM</small> */}
                              </h6>
                              </Link>
                              <p className="mb-0">{notify.description}.</p>
                            </div>
                          </div>
                        </li>
                      );
                    })
                  }
                  {/* <li className="bg-light txt-dark"><a href="index.html#">All</a> notification</li> */}
                </ul>}
                {notification?.value > 0 && <div className="dotted-animation"><span className="animate-circle"></span><span className="main-circle"></span></div>}
      </>
    )
}

export default Notification
